import styled from "styled-components";
import bracketImage from "./img/bracket.png";
import {
  ChartTopBar,
  ChartBottomBar,
  Chart,
  ChartTable,
  WonModal,
  LoseModal,
} from "./components";
import { BARS_ROUND_REWARD, BARS_MAX_PER_DAY } from "./constants";
import { useModal, Typography } from "@bracket/ui";
import { useInOrOutStore } from "./store/InOrOutStore";
import { useEffect, useState } from "react";
import { InOrOutLogo } from "./components/InOrOutLogo";

const GameLayoutWrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  padding: 0rem;
  gap: 1.5rem;
  overflow-x: hidden;
`;

const ChartSection = styled.div`
  display: flex !important;
  flex-flow: column !important;
  position: relative;
`;

const BracketImage = styled.img`
  position: absolute;
  bottom: 40px;
  right: -20px;
  z-index: -1;
  opacity: 0.25;
`;

const StyledTypography = styled(Typography)`
  font-size: 2rem !important;
`;

export const GameLayout = () => {
  const { openModal, closeModal, isOpen } = useModal();

  const {
    currentResult,
    barsWonToday,
    activeGameState,
    playStart,
    resetPlay,
    history,
    hasStaked,
  } = useInOrOutStore();

  const [barsWon, setBarsWon] = useState(barsWonToday);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const onWillStayClick = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 2000);
    playStart("IN");
  };

  const onWillBreakOutClick = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 2000);
    playStart("OUT");
  };

  const onModalClose = () => {
    closeModal();
    console.log("set bars won", barsWon, barsWonToday);
    setBarsWon(barsWonToday);
  };

  useEffect(() => {
    if (activeGameState?.result === "win") {
      setTimeout(() => {
        openModal(<WonModal closeModal={onModalClose} />);
        resetPlay();
      }, 1000);
    }

    if (activeGameState?.result === "loose") {
      setTimeout(() => {
        openModal(<LoseModal closeModal={onModalClose} />);
        resetPlay();
      }, 1000);
    }
  }, [activeGameState?.result]);

  useEffect(() => {
    if (!isOpen && barsWonToday !== barsWon) {
      setBarsWon(barsWonToday);
    }
  }, [isOpen, barsWonToday]);

  const buttonDisabled =
    isButtonDisabled || !!activeGameState || history.length < 5;

  return (
    <GameLayoutWrapper>
      <InOrOutLogo />
      <StyledTypography variant="h3">
        Will the price break out of the next 10 seconds?
      </StyledTypography>
      <ChartSection>
        <ChartTopBar
          ethPrice={currentResult?.price.toFixed(2) || 0}
          barsWonToday={barsWon}
          maxBarsPerDay={BARS_MAX_PER_DAY}
          time={activeGameState?.timeLeft ?? 10}
          isGameActive={!!activeGameState}
        />
        <Chart />
        <BracketImage src={bracketImage} alt="Bracket" />
      </ChartSection>

      <ChartBottomBar
        reward={BARS_ROUND_REWARD}
        isDisabled={buttonDisabled}
        onWillStayClick={onWillStayClick}
        onWillBreakOutClick={onWillBreakOutClick}
        hasStaked={hasStaked}
        barsExceeded={barsWonToday >= BARS_MAX_PER_DAY}
      />
      <ChartTable />
    </GameLayoutWrapper>
  );
};
